import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-subscription-credits',
    templateUrl: './subscription-credits.component.html',
    standalone: false
})
export class SubscriptionCreditsComponent {
  @Input() credit: number;
}
